import visitorCountFromSchema, { visitorCount, visitorsFromSchema } from '@genericBookings/visitorUtils';
import { getAPIBase, getAPIRoutes } from './getAPIBase';
class API {
    static API_BASE = getAPIBase(MODE);
    static API_ROUTES = getAPIRoutes(MODE);
    static readProduct(productID) {
        const formData = new FormData();
        formData.set('SelectedValue', `${productID}`);
        return API._makeRequest(API.API_ROUTES.readProducts, 'POST', formData);
    }
    static dayPrices(productID, priceBandId, fromDate, toDate, visitors = {}) {
        const formData = new FormData();
        formData.set('ProductId', `${productID}`);
        formData.set('PriceBandId', `${priceBandId}`);
        formData.set('FromDate', fromDate);
        formData.set('ToDate', toDate);
        Object.values(visitors).forEach((visitorNumber, idx) => {
            const visitorString = Object.keys(visitors)[idx];
            formData.set(visitorString, `${visitorNumber}`);
        });
        return API._makeRequest(API.API_ROUTES.dayPrices, 'POST', formData);
    }
    static levelChange(productID) {
        const formData = new FormData();
        formData.set('SelectedValue', productID);
        return API._makeRequest(API.API_ROUTES.levelChange, 'POST', formData);
    }
    static cancelBooking(bookingId) {
        const formData = new FormData();
        formData.set('BookingId', `${bookingId}`);
        return API._makeRequest(API.API_ROUTES.cancelBooking, 'POST', formData);
    }
    static newsletterRegistration(email) {
        const formData = new FormData();
        formData.set('email', email);
        return API._makeRequest(API.API_ROUTES.newsletterRegistration, 'POST', formData);
    }
    static signature(termsAgreed, signatureName, signatureDate) {
        const formData = new FormData();
        formData.set('TermsAgreed', termsAgreed);
        formData.set('SignatureName', signatureName);
        formData.set('SignatureDate', signatureDate);
        return API._makeRequest(API.API_ROUTES.signature, 'POST', formData);
    }
    static retentionRegistration(email) {
        const formData = new FormData();
        formData.set('email', email);
        return API._makeRequest(API.API_ROUTES.retentionRegistration, 'POST', formData);
    }
    static searchSite(search, offset) {
        const queryParams = new URLSearchParams({ search, offset: `${offset}` }).toString();
        return API._makeRequest(`${API.API_ROUTES.search}?${queryParams}`, 'GET', null);
    }
    static getActivitiesAvailableForDate(dayTicketId, date) {
        const formData = new FormData();
        formData.set('VisitDate', date);
        formData.set('DayTicketId', `${dayTicketId}`);
        return API._makeRequest(`${API.API_ROUTES.activitiesAvailableOnDate}`, 'POST', formData);
    }
    static hasSessions(productID, fromDate, toDate, visitors = {}) {
        const formData = new FormData();
        formData.set('SelectedValue', `${productID}`);
        formData.set('FromDate', fromDate);
        formData.set('ToDate', toDate);
        Object.values(visitors).forEach((visitorNumber, idx) => {
            const visitorString = Object.keys(visitors)[idx];
            formData.set(visitorString, `${visitorNumber}`);
        });
        return API._makeRequest(API.API_ROUTES.hasSessions, 'POST', formData);
    }
    static hasDaySessions(dayTicketID, fromDate, toDate, visitors = {}) {
        const formData = new FormData();
        formData.set('DayTicketId', `${dayTicketID}`);
        formData.set('FromDate', fromDate);
        formData.set('ToDate', toDate);
        Object.values(visitors).forEach((visitorNumber, idx) => {
            const visitorString = Object.keys(visitors)[idx];
            formData.set(visitorString, `${visitorNumber}`);
        });
        return API._makeRequest(API.API_ROUTES.hasDaySessions, 'POST', formData);
    }
    static getSessions(data) {
        const queryParams = new URLSearchParams({ ...data }).toString();
        return API._makeRequest(`${API.API_ROUTES.getSessions}?${queryParams}`, 'GET', null);
    }
    static hasAvailability(id, date, visitors, isDayTickets = false) {
        const formData = new FormData();
        const idKey = isDayTickets ? 'DayBuilderId' : 'ProductId';
        formData.set(idKey, `${id}`);
        formData.set('VisitDate', `${date}`);
        Array(9).fill(0).forEach((_, idx) => {
            const key = `Visitors${idx}`;
            formData.set(`Visitors${idx}`, `${visitors[key]}`);
        });
        const route = isDayTickets ? API.API_ROUTES.dayTicketAvailability : API.API_ROUTES.hasAvailability;
        return API._makeRequest(`${route}`, 'POST', formData);
    }
    static reserveSingleSession(data) {
        const formData = new FormData();
        formData.set('VisitDate', `${data.VisitDate}`);
        formData.set('ProductId', `${data.ProductId}`);
        formData.set('SessionId', `${data.session}`);
        formData.set('Visitors0', `${data.Visitors0}`);
        formData.set('Visitors1', `${data.Visitors1}`);
        formData.set('Visitors2', `${data.Visitors2}`);
        formData.set('Visitors3', `${data.Visitors3}`);
        formData.set('Visitors4', `${data.Visitors4}`);
        formData.set('Visitors5', `${data.Visitors5}`);
        formData.set('Visitors6', `${data.Visitors6}`);
        formData.set('Visitors7', `${data.Visitors7}`);
        formData.set('Visitors8', `${data.Visitors8}`);
        return API._makeRequest(API.API_ROUTES.reserveSession, 'POST', formData);
        // formData.set('FromDate', fromDate);
        // formData.set('ToDate', toDate);
        //
        // Object.values(visitors).forEach((visitorNumber, idx) => {
        //   const visitorString = Object.keys(visitors)[idx];
        //   formData.set(visitorString, `${visitorNumber}`);
        // });
        // API._makeRequest(`${API.API_ROUTES.hasAvailability}`, 'POST', data);
    }
    static reserveMultipleSessions(data) {
        const sessions = data.Sessions.filter((session) => session.SessionId !== undefined && session.SessionId !== null);
        return sessions.map((session) => {
            const formData = new FormData();
            formData.set('VisitDate', `${data.VisitDate}`);
            formData.set('ProductId', `${session.ActivityId}`);
            formData.set('SessionId', `${session.SessionId}`);
            formData.set('Visitors0', `${session.Visitors0}`);
            formData.set('Visitors1', `${session.Visitors1}`);
            formData.set('Visitors2', `${session.Visitors2}`);
            formData.set('Visitors3', `${session.Visitors3}`);
            formData.set('Visitors4', `${session.Visitors4}`);
            formData.set('Visitors5', `${session.Visitors5}`);
            formData.set('Visitors6', `${session.Visitors6}`);
            formData.set('Visitors7', `${session.Visitors7}`);
            formData.set('Visitors8', `${session.Visitors8}`);
            return API._makeRequest(API.API_ROUTES.reserveSession, 'POST', formData);
        });
    }
    static register(data) {
        const formData = new FormData();
        formData.set('FirstName', `${data.firstName}`);
        formData.set('LastName', `${data.surname}`);
        formData.set('EmailAddress', `${data.email}`);
        formData.set('Password', `${data.password}`);
        formData.set('PhoneNumber', `${data.mobile}`);
        formData.set('DateOfBirth', `${data.dateOfBirth}`);
        formData.set('AddressLine1', `${data.addressLine1}`);
        formData.set('AddressLine2', `${data.addressLine2}`);
        formData.set('AddressCity', `${data.addressTown}`);
        formData.set('AddressPostcode', `${data.addressPostcode}`);
        formData.set('AddressCountry', `${data.addressCountry}`);
        formData.set('MarketingPreferences', `${data.marketingPreferences}`);
        return API._makeRequest(API.API_ROUTES.register, 'POST', formData);
    }
    static account(data) {
        const formData = new FormData();
        formData.set('FirstName', `${data.firstName}`);
        formData.set('LastName', `${data.surname}`);
        formData.set('EmailAddress', `${data.email}`);
        formData.set('PhoneNumber', `${data.mobile}`);
        formData.set('DateOfBirth', `${data.dateOfBirth}`);
        formData.set('AddressLine1', `${data.addressLine1}`);
        formData.set('AddressLine2', `${data.addressLine2}`);
        formData.set('AddressCity', `${data.addressTown}`);
        formData.set('AddressPostcode', `${data.addressPostcode}`);
        formData.set('AddressCountry', `${data.addressCountry}`);
        formData.set('MarketingPreferences', `${data.marketingPreferences}`);
        return API._makeRequest(API.API_ROUTES.modifyAccount, 'POST', formData);
    }
    static directDebit(data) {
        const formData = new FormData();
        formData.set('AccountName', `${data.accountName}`);
        formData.set('SortCode', `${data.sortCode}`);
        formData.set('AccountNumber', `${data.accountNumber}`);
        formData.set('TermsAccepted', `${data.termsAccepted}`);
        formData.set('DirectDebitAccepted', `${data.directDebitAccepted}`);
        return API._makeRequest(API.API_ROUTES.directDebit, 'POST', formData);
    }
    static resetPassword(data) {
        const formData = new FormData();
        formData.set('Password', `${data.password}`);
        formData.set('ConfirmPassword', `${data.confirmPassword}`);
        return API._makeRequest(API.API_ROUTES.resetPassword, 'POST', formData);
    }
    static changePassword(data) {
        const formData = new FormData();
        formData.set('Password', `${data.password}`);
        formData.set('NewPassword', `${data.newPassword}`);
        formData.set('ConfirmPassword', `${data.confirmPassword}`);
        return API._makeRequest(API.API_ROUTES.changePassword, 'POST', formData);
    }
    static login(data) {
        const formData = new FormData();
        formData.set('EmailAddress', `${data.email}`);
        formData.set('Password', `${data.password}`);
        return API._makeRequest(API.API_ROUTES.login, 'POST', formData);
    }
    static loginChild(username, password, contactId) {
        const formData = new FormData();
        formData.set('EmailAddress', `${username}`);
        formData.set('Password', `${password}`);
        formData.set('ContactId', `${contactId}`);
        return API._makeRequest(API.API_ROUTES.loginChild, 'POST', formData);
    }
    static logout(logoutAllSessions) {
        const formData = new FormData();
        formData.set('AllSessions', `${logoutAllSessions}`);
        return API._makeRequest(API.API_ROUTES.logout, 'POST', formData);
    }
    static forgotPassword(data) {
        const formData = new FormData();
        formData.set('EmailAddress', `${data.email}`);
        return API._makeRequest(API.API_ROUTES.forgotPassword, 'POST', formData);
    }
    static reserveDayTicket(data) {
        const formData = new FormData();
        formData.set('VisitDate', `${data.VisitDate}`);
        formData.set('DayTicketId', `${data.DayTicketId}`);
        formData.set('Sessions', `${JSON.stringify(data.Sessions.map((session) => ({
            ProductId: session.ActivityId,
            SessionId: session.SessionId,
        })))}`);
        formData.set('Visitors0', `${data.Visitors0}`);
        formData.set('Visitors1', `${data.Visitors1}`);
        formData.set('Visitors2', `${data.Visitors2}`);
        formData.set('Visitors3', `${data.Visitors3}`);
        formData.set('Visitors4', `${data.Visitors4}`);
        formData.set('Visitors5', `${data.Visitors5}`);
        formData.set('Visitors6', `${data.Visitors6}`);
        formData.set('Visitors7', `${data.Visitors7}`);
        formData.set('Visitors8', `${data.Visitors8}`);
        return API._makeRequest(API.API_ROUTES.reserveDayTicket, 'POST', formData);
    }
    static reserveDayTicketBuilder(data) {
        const formData = new FormData();
        formData.set('VisitDate', `${data.VisitDate}`);
        formData.set('DayTicketId', `${data.DayTicketId}`);
        formData.set('Sessions', `${JSON.stringify(data.Sessions
            .filter((session) => visitorCountFromSchema(session) !== 0 && session.SessionId !== null)
            .map((session) => {
            const visitors = visitorsFromSchema(session);
            const formattedSession = {
                ProductId: session.ActivityId,
                SessionId: session.SessionId,
            };
            if (visitorCount(visitors)) {
                Object.keys(visitors)
                    .forEach((key) => {
                    formattedSession[key] = visitors[key];
                });
            }
            return formattedSession;
        }))}`);
        return API._makeRequest(API.API_ROUTES.reserveDayTicket, 'POST', formData);
    }
    /**
     *
     * @param dayTicketId id of the pre-made day ticket
     * @param fromDate the from date for the day ticket
     * @param toDate the to date for the day ticket
     *
     * @returns string[] the dates that ara available in y-m-d e.g. 2025-01-05
     */
    static hasDayTicketAvailability(dayTicketId, fromDate, toDate) {
        const formData = new FormData();
        formData.set('SelectedValue', `${dayTicketId}`);
        formData.set('FromDate', fromDate);
        formData.set('ToDate', toDate);
        return API._makeRequest(API.API_ROUTES.dayTicketAvailability, 'POST', formData);
    }
    static getSessionsById(productID, dayTicketId, date, visitors) {
        const formData = new FormData();
        formData.set('ProductId', `${productID}`);
        formData.set('DayTicketId', `${dayTicketId}`);
        formData.set('Date', date);
        formData.set('Visitors0', `${visitors.Visitors0}`);
        formData.set('Visitors1', `${visitors.Visitors1}`);
        formData.set('Visitors2', `${visitors.Visitors2}`);
        formData.set('Visitors3', `${visitors.Visitors3}`);
        formData.set('Visitors4', `${visitors.Visitors4}`);
        formData.set('Visitors5', `${visitors.Visitors5}`);
        formData.set('Visitors6', `${visitors.Visitors6}`);
        formData.set('Visitors7', `${visitors.Visitors7}`);
        formData.set('Visitors8', `${visitors.Visitors8}`);
        return API._makeRequest(API.API_ROUTES.getActivitySessions, 'POST', formData);
    }
    static getSessionsForActivity(data) {
        const queryParams = new URLSearchParams({ ...data }).toString();
        console.log('Query params: ', queryParams);
        return API._makeRequest(`${API.API_ROUTES.getActivitySessions}?${queryParams}`, 'GET', null);
    }
    static readPrices(productID, date) {
        const formData = new FormData();
        formData.set('ProductId', `${productID}`);
        formData.set('Date', date);
        return API._makeRequest(API.API_ROUTES.readPrices, 'POST', formData);
    }
    static adjustProductQty(sessionId, priceBandId, value, priceBands) {
        const unitTotal = API.getPriceBandUnitTotal(priceBandId, value, priceBands);
        console.log('Unit Total: ', unitTotal);
        // if value is 0 remove it instead
        if (unitTotal < 1) {
            return API.removeProduct(sessionId);
        }
        const formData = new FormData();
        formData.set('SessionId', `${sessionId}`);
        formData.set('PriceBandId', `${priceBandId}`);
        formData.set('NewValue', `${value}`);
        formData.set('IsDelete', `${false}`);
        return API._makeRequest(API.API_ROUTES.adjustProductQty, 'POST', formData);
    }
    static removeProduct(sessionId) {
        const formData = new FormData();
        formData.set('SessionId', `${sessionId}`);
        return API._makeRequest(API.API_ROUTES.trashProduct, 'POST', formData);
    }
    static getPriceBandUnitTotal(priceBandId, value, priceBands) {
        // make a copy of the price bands
        const newPriceBands = [...priceBands].map((band) => {
            const newBand = band;
            if (band.PriceBandId === priceBandId) {
                newBand.Units = parseInt(`${value}`, 10);
            }
            return newBand;
        });
        return newPriceBands.reduce((carry, band) => carry + band.Units, 0);
    }
    static adjustMiscProductQty(miscId, miscType, priceBandId, value, priceBands, addMisc = false) {
        const unitTotal = API.getPriceBandUnitTotal(priceBandId, value, priceBands);
        // if value is 0 remove it instead
        if (unitTotal < 1) {
            return API.removeMiscProduct(miscId, miscType);
        }
        const formData = new FormData();
        formData.set('MiscellaneousId', `${miscId}`);
        formData.set('MiscellaneousType', `${miscType}`);
        formData.set('PriceBandId', `${priceBandId}`);
        formData.set('NewValue', `${value}`);
        formData.set('IsDelete', `${false}`);
        return API._makeRequest(!addMisc ? API.API_ROUTES.adjustMiscProductQty : API.API_ROUTES.addMisc, 'POST', formData);
    }
    static removeMiscProduct(miscId, miscType) {
        const formData = new FormData();
        formData.set('MiscellaneousId', `${miscId}`);
        formData.set('MiscellaneousType', `${miscType}`);
        return API._makeRequest(API.API_ROUTES.trashMiscProduct, 'POST', formData);
    }
    static removeUpsellProduct(upsellId) {
        const formData = new FormData();
        formData.set('UpsellId', `${upsellId}`);
        return API._makeRequest(API.API_ROUTES.trashUpsellProduct, 'POST', formData);
    }
    static addUpsellItem(upsellId, value) {
        const formData = new FormData();
        formData.set('UpsellId', `${upsellId}`);
        formData.set('NewValue', `${value}`);
        return API._makeRequest(API.API_ROUTES.addUpsellItem, 'POST', formData);
    }
    static adjustUpsellProductQuantity(upsellId, priceBandId, value, priceBands) {
        const unitTotal = API.getPriceBandUnitTotal(priceBandId, value, priceBands);
        console.log('Unit Total: ', unitTotal);
        // if value is 0 remove it instead
        if (unitTotal < 1) {
            return API.removeUpsellProduct(upsellId);
        }
        const formData = new FormData();
        formData.set('UpsellId', `${upsellId}`);
        formData.set('PriceBandId', `${priceBandId}`);
        formData.set('NewValue', `${value}`);
        formData.set('IsDelete', `${false}`);
        return API._makeRequest(API.API_ROUTES.adjustUpsellProductQty, 'POST', formData);
    }
    static siteVerify(token) {
        const formData = new FormData();
        formData.set('token', `${token}`);
        return API._makeRequest(API.API_ROUTES.verifyCaptcha, 'POST', formData);
    }
    /**
     * Add voucher code, either gift voucher or promo code.
     *
     * @param coupon code of either gift voucher or voucher code
     */
    static checkVoucherCode(coupon) {
        const formData = new FormData();
        formData.set('coupon', coupon);
        return API._makeRequest(API.API_ROUTES.addVoucher, 'POST', formData);
    }
    static applyGiftVoucher(coupon, amount) {
        const formData = new FormData();
        formData.set('voucherCode', coupon);
        formData.set('redeemAmount', `${amount}`);
        return API._makeRequest(API.API_ROUTES.giftVoucher, 'POST', formData);
    }
    static addGiftVoucher(voucher) {
        const formData = new FormData();
        formData.set('voucher', voucher);
        return API._makeRequest(API.API_ROUTES.addGiftVoucher, 'POST', formData);
    }
    static _makeRequest(url, type, data) {
        return fetch(`${API.API_BASE}/${url}`, {
            method: type || 'GET',
            redirect: 'error',
            mode: 'cors',
            referrer: 'no-referrer',
            headers: {
                Accept: 'application/json, text/plain, */*',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: type !== 'GET' ? data : null,
        })
            .then(async (response) => {
            if (response.ok) {
                const contentType = response.headers.get('content-type');
                if (contentType && contentType.indexOf('application/json') !== -1) {
                    return response.json().then((json) => Promise.resolve(json));
                }
                return response.text().then((text) => Promise.resolve(text));
            }
            const error = await response.json();
            return Promise.reject(error);
        })
            .catch((err) => Promise.reject(err));
    }
}
export default API;
